import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import GasService from '../../services/GasService.js'
import '@isceco/widget-library2/basic-elements/DateInput/DateInput.js'
import '../../components/Schweizerkarte/SchweizerkarteUebersicht.js'
import '../../components/SchweizerkarteLegende/SchweizerkarteLegende.js'
import ChartService from '../Verbrauch/Region/ChartService.js'
import '@isceco/widget-library2/basic-elements/Card/Card.js'
import '@isceco/widget-library2/basic-elements/Link/Link.js'

export default class Cockpit extends WebComponent {

  get css() {
    return css`

      .legende {
        margin: 0 0 5px 0;
        padding-top: 0;
      }

      .row {
        display: flex;
        align-items: center; /* Align dot and text vertically */
        margin-bottom: 10px; /* Space between rows */
      }

      .dot {
        width: 55px;
        height: 30px;
      }


      isceco-popup > .info {
        margin-top: 4px;
      }

      .dot.green {
        background-color: var(--isceco-color-green-300);
      }

      .dot.orange {
        background-color: var(--isceco-color-yellow-500);
      }

      .dot.red {
        background-color: var(--isceco-color-red-500);
      }

      .externe-links {
        padding-top: 0;
      }

      .externe-links-content {
        display: grid;
        grid-template-rows: auto;
        padding-top: 8px;
        text-wrap: nowrap;
      }
    `
  }

  get translationFile() {
    return './views/Cockpit/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.chartService = new ChartService()
    this.reload()
  }

  reload() {
    const gasService = new GasService()
    this.regions = {}
    const today = offsetDate({})
    const end = offsetDate({d: 14})

    Promise.all([
      gasService.getFluesse(today),
      this._fetchRegion('dch', today, end),
      this._fetchRegion('gaznat', today, end),
      this._fetchRegion('ail', today, end)
    ])
      .then(([json, _1, _2, _3]) => {
        this.data = json
        this.render()
      })
      .catch(_ => {
        this.render()
      })
  }

  _fetchRegion = (region, start, end) => {
    return Promise.all([
      this.chartService.getVerbrauchPrognose(region, start, end),
      this.chartService.getGebuchteKapazitaet(region, start, end)])
      .then(([prognose, gebucht]) => {
        const max = prognose.map((p, i) => this._ratio(p.value, gebucht[i].value))
        this.regions[region] = Math.max(...max)
      })
  }

  _ratio = (prognose, gebucht) => {
    const ratio = prognose / gebucht
    return isNaN(ratio) || ratio === Infinity || ratio === -Infinity ? 0 : ratio
  }

  getTemplate() {
    return html`
      <div style="display: flex; align-items: center;">
        <div style="width: 100%;">
          <gasmonitoring-schweizerkarte-uebersicht id="karte"
                                                   .data="${this.data}"
                                                   .regions="${this.regions}"
                                                   .i18n="${this.i18n}"
          ></gasmonitoring-schweizerkarte-uebersicht>
        </div>
        <div style="margin-left: 160px; font-size: small;">
          <isceco-card class="externe-links">
            <div>${this.i18n.translate('landingpage.externe.quellen.title')}</div>
            <div class="externe-links-content">
              ${this.renderLinks()}
            </div>
          </isceco-card>
        </div>
      </div>
    `
  }

  renderLinks() {
    const links = ['entsog', 'routes', 'giealsi', 'eex', 'bfe', 'bnetza', 'marketmsgs', 'fluxys', 'physflows', 'frlage', 'rapporte', 'tempjahr', 'pubmeteo']
    return links.map(link => this.renderLink(link));
  }

  renderLink(link) {
    return html`
      <isceco-link
        target="_blank"
        text="${this.i18n.translate('landingpage.externe.quellen.' + link)}"
        icon="external square alternate" url="${this.i18n.translate(`landingpage.externe.quellen.${link}.url`)}">
      </isceco-link>
    `
  }
}
customElements.define('gasmonitoring-frontend-cockpit', Cockpit)
